import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export type Achievement = {
	id: string;
	name: string;
	congratulations_description: string;
	description: string;
	type: "account" | "integration" | "achievement" | "award";
	checked: boolean;
};

export async function fetchAchievements(): Promise<
	| {
			status: "success";
			data: Achievement[];
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.get("/achievements-user");

		return {
			status: "success",
			data: data.data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
